import React from 'react';

import WelcomeFeature from '@features/welcome';
import { useFormStore } from '@store/use-form-store';

import { useElearningWpRemoteFlow } from './shared/ewr-flow-context';

function ElearningWpRemoteWelcomePage() {
  const { goNext } = useElearningWpRemoteFlow();
  const { changeRegistrationType, resetProcess } = useFormStore();

  const handleRegister = (type: string) => {
    resetProcess();
    changeRegistrationType(type);
    goNext();
  };

  return (
    <WelcomeFeature
      onSingleRegister={() => handleRegister('single')}
      onMultipleRegister={() => handleRegister('multiple')}
    />
  );
}

export default ElearningWpRemoteWelcomePage;
